import React from "react";
import SectionCarouselNav from "../../DashboardCourses/components/SectionCarouselNav";
import { useHorizontalCarousel } from "../../DashboardCourses/hooks/useHorizontalCarousel";
import { getExploreCardClassName } from "../../DashboardCourses/utils/exploreCardHighlight";
import { getQuickActionAnchorId } from "../utils/studyDashboardScrollRestore";
import "../../DashboardCourses/components/dashboardExploreCard.css";
import "./QuickActions.css";

const QuickActions = ({
  items = [],
  onItemClick,
  highlightedAnchorId = null,
  initialPageIndex = 0,
}) => {
  const {
    viewportRef,
    trackRef,
    trackOffset,
    pageIndex,
    canScrollLeft,
    canScrollRight,
    hasOverflow,
    scrollByPage,
  } = useHorizontalCarousel(items.length, "", initialPageIndex);

  if (!items.length) return null;

  return (
    <section className="quick-actions" aria-labelledby="quick-actions-title">
      <div className="quick-actions__header">
        <h2 id="quick-actions-title" className="quick-actions__title">
          Quick Actions
        </h2>
        {hasOverflow ? (
          <SectionCarouselNav
            canScrollLeft={canScrollLeft}
            canScrollRight={canScrollRight}
            onPrev={() => scrollByPage(-1)}
            onNext={() => scrollByPage(1)}
            ariaLabel="Quick Actions navigation"
          />
        ) : null}
      </div>

      <div className="quick-actions__carousel">
        <div ref={viewportRef} className="quick-actions__viewport">
          <div
            ref={trackRef}
            className="quick-actions__track"
            style={{ transform: `translate3d(-${trackOffset}px, 0, 0)` }}
          >
            {items.map((item) => {
              const anchorId = getQuickActionAnchorId(item.id);
              const isSelected = Boolean(
                anchorId && highlightedAnchorId === anchorId
              );

              return (
                <button
                  key={item.id}
                  id={anchorId}
                  type="button"
                  className={getExploreCardClassName(
                    "quick-actions__card",
                    anchorId,
                    highlightedAnchorId
                  )}
                  aria-current={isSelected ? "true" : undefined}
                  onClick={() => onItemClick?.(item, { pageIndex, anchorId })}
                >
                  {item.icon ? (
                    <div className="quick-actions__icon-wrap">
                      <img src={item.icon} alt="" aria-hidden="true" />
                    </div>
                  ) : null}
                  <div className="quick-actions__text">
                    <strong>{item.name}</strong>
                    {item.subtitle ? <span>{item.subtitle}</span> : null}
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuickActions;
